import React, { useState } from 'react';
import Modal from "../ui/components/modals/modal";
import PolicyWording from '../assets/pdf/BIZQRI001-Q-0818.pdf';
import styled from  'styled-components';
import './modal-exclusions.css';

const ModalExcWordingContent = styled.div`
    margin-bottom: 24px;
    ${props => {
        return !props.show ? 'display: none' : '';
    }}
`

function ModalExclusions({
    showModal,
    hideModal
}) {
    const [display, setDisplay] = useState({
        property: false,
        businessInter: false,
        money: false,
        personalAccident: false,
        liability: false,
        workInjuryComp: false,
        fidelity: false,
        general: false,
    });
    const custom = {};
    
    return (
        <Modal
            className="ModalExcBody"
            onClose={() => {
                setDisplay({
                    property: false,
                    businessInter: false,
                    money: false,
                    personalAccident: false,
                    liability: false,
                    workInjuryComp: false,
                    fidelity: false,
                    general: false,
                })
                hideModal();
            }}
            isOpen={showModal}>
            <div className="ModalExcTitle">
                Exclusions
            </div>
            <div className="ModalExcContent" style={custom}>
                <b>
                    Some items or events may not be covered by our policy. We want you to know about these because we feel this is
                    important for you to understand when you buy your insurance. Please click on the title below to view the key
                    exclusions:
                </b>
                <div>
                    <ol>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, property: !display.property})}}>Property</li>
                    <ModalExcWordingContent show={display.property}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Property
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Loss of or damage to <i>Money, jewellery, furs or bullion</i></li>
                                <li>Loss of or damage to <i>living creatures (animals, birds or fish)</i></li>
                                <li>Mechanical breakdown of <i>Machinery</i></li>
                                <li>Damage caused by <i>rodents, insects and other vermin</i></li>
                                <li>Damage which happens or occurs gradually such as <i>rust, pollution or evaporation</i></li>
                                <li>Where property is stolen <i>without using force to enter the premises</i></li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <ModalExcWordingContent show={display.property}>
                        <div className="ModalExcWordingTitle">
                            Where you may not be fully paid for your Property claim
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Where you declare a sum insured which is much less than the value of the property that you are insuring for.</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, businessInter: !display.businessInter})}}>Business Interruption</li>
                    <ModalExcWordingContent show={display.businessInter}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Business Interruption
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Where a claim has not been <i>made against and accepted under a Property Insurance policy</i></li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, money: !display.money})}}>Money</li>
                    <ModalExcWordingContent show={display.money}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Money
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Your loss of money is the result of theft or dishonesty by one of your employees</li>
                                <li>Your money cannot be accounted for because of a clerical or accounting error</li>
                                <li>Where it has been stolen from a safe or strongroom by people to who you have given the keys or the combination.</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, personalAccident: !display.personalAccident})}}>Personal Accident</li>
                    <ModalExcWordingContent show={display.personalAccident}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Personal Accident
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Where death or disability <i>results from illness</i></li>
                                <li>If the death or disability results from <i>taking part in dangerous activities</i> such as skydiving.</li>
                                <li>As a result of <i>AIDS/HIV or a sexually transmitted disease.</i></li>
                                <li>An intentional <i>self-inflicted injury</i></li>
                                <li>Where the death or disability occurs to <i>a person over 75 years of age.</i></li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, liability: !display.liability})}}>Liability</li>
                    <ModalExcWordingContent show={display.liability}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Liability
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Injury or damage claimed by <i>an employee in the course of their employment</i></li>
                                <li>Claims for injuries or damage <i>caused by your products.</i></li>
                                <li>Any <i>Pollution caused by you</i></li>
                                <li>Any claim against you <i>involving asbestos in any form</i></li>
                                <li>Where you <i>fail to render any professional advice</i> or you make an <i>error or an omission in connection with advice</i> you do give.</li>
                                <li>Loss or Damage to <i>property which is in your custody</i></li>
                                <li>The part of any amount of damages awarded against you that are <i>Punitive, Exemplary or Aggravated damages.</i></li>
                                <li><i>Fines or penalties which are made against you or your business.</i></li>
                                <li>The cost of fixing any <i>faulty workmanship which you are responsible for.</i></li>
                                <li>Liability arising out of your <i>use of any registered vehicles</i></li>
                                <li>Any claims of Molestation</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <ModalExcWordingContent show={display.liability}>
                        <div className="ModalExcWordingTitle">
                            Where cover may not be provided for Liability
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>Claim arising out of electronic data</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, workInjuryComp: !display.workInjuryComp})}}>Work Injury Compensation</li>
                    <ModalExcWordingContent show={display.workInjuryComp}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Work Injury Compensation
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>For injuries to <i>people who are not your employees</i></li>
                                <li>Where an injury arises out of deliberate <i>self-injury</i></li>
                                <li>Where any <i>injury or illness is due to asbestos</i></li>
                                <li>Where any <i>injury or illness is due to the effects of alcohol or non-prescription drugs</i></li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, fidelity: !display.fidelity})}}>Fidelity</li>
                    <ModalExcWordingContent show={display.fidelity}>
                        <div className="ModalExcWordingTitle">
                            Where cover is not provided for Fidelity
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>The amount of any loss that occurs <i>after you become aware of an employee's dishonesty.</i></li>
                                <li><i>If you do not tell us of an act of dishonesty</i> within 30 days of you discovering it.</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <ModalExcWordingContent show={display.fidelity}>
                        <div className="ModalExcWordingTitle">
                            When you may not be fully paid for a Fidelity claim
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>If the losses from the <i>dishonest acts span more than one period of insurance</i></li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <li className="ModalExcListTitle" onClick={() => {setDisplay({...display, general: !display.general})}}>General</li>
                    <ModalExcWordingContent show={display.general}>
                        <div className="ModalExcWordingTitle">
                            Where cover <u>may</u> not be provided by the policy under any Cover section
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>If you change the <i>nature of your business</i> and do not tell us</li>
                                <li>Where the damage or loss or injury arises out of your not taking a reasonable level of care.</li>
                                <li>Where you fail to disclose information to us that is relevant to us making a decision to insure you and on what terms.</li>
                                <li>If you intentionally did not describe your risk properly to us</li>
                                <li>Damage or liability due to cyber crime</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    <ModalExcWordingContent show={display.general}>
                        <div className="ModalExcWordingTitle">
                            Where cover <u>will</u> not be provided by the policy under any Cover section
                        </div>
                        <div className="ModalExcWordingDetail">
                            <ul>
                                <li>If we are prohibited from providing cover to you due to a United Nations resolutions or the trade laws of any country.</li>
                                <li>Loss, damage or injury resulting from an Act of Terrorism.</li>
                                <li>Loss, damage or injury due to War or Civil War.</li>
                                <li>Lawful confiscation of your property by government or other authorities</li>
                                <li>If you make a fraudulent claim</li>
                                <li>Any loss damage or injury involving Nuclear materials or weapons</li>
                                <li>Computer virus causing loss or damage to electronic data</li>
                            </ul>
                        </div>
                    </ModalExcWordingContent>
                    </ol>
                </div>
                <b>
                    This is not a complete list of general exclusions under the policy. To view the full cover and exclusions, please view our<span> </span>
                    <a href={PolicyWording} target="_blank">Policy Wording</a>
                </b>
            </div>
        </Modal>
    );
}


export default ModalExclusions;
